import React from 'react';
import PesadaSegunda from '../../components/balanza/SegundaPesada';
import { PageWrapper } from '../../components/common';

const SegundaPesada: React.FC = () => {
  return (
    <PageWrapper>
      <PesadaSegunda />
    </PageWrapper>
  );
};  

export default SegundaPesada;